import _ from 'lodash'
import PropTypes from 'prop-types'
import { useRef, useState } from 'react'

import { Button } from '@/components/elements/button'
import { Input } from '@/components/elements/input'
import { Label } from '@/components/elements/label'
import { MultiSelect } from '@/components/MultiSelect'
import { Select } from '@/components/Select'
import { hasAnyValues } from '@/utils/helpers'

export const DataTableFilter = ({ filters, setFilters, filterValues }) => {
  const [localValues, setLocalValues] = useState(filterValues || {})

  function setFilter(id, value, debounce = false) {
    setLocalValues((prev) => ({
      ...prev,
      [id]: value || null,
    }))
    if (debounce) {
      debounceSetFilter(id, value)
    } else {
      setFilters((prev) => ({
        ...prev,
        [id]: value || null,
      }))
    }
  }

  const debounceSetFilter = useRef(_.debounce(setFilter, 500)).current

  const resetFilters = () => {
    setLocalValues({})
    setFilters({})
  }
  if (!filters || filters.length === 0) return null

  return (
    <div className="flex flex-wrap items-center gap-2">
      {filters.map((filter) => (
        <div className="flex flex-col gap-1" key={filter.id}>
          <Label className="text-sm" htmlFor={`filter-${filter.id}`}>
            {filter.label}
          </Label>
          {filter.type === 'select' && (
            <Select
              id={`filter-${filter.id}`}
              key={filter.id}
              onChange={(value) => {
                setFilter(filter.id, value)
              }}
              options={filter.options}
              value={localValues[filter.id]}
              className="w-full md:w-56"
            />
          )}
          {filter.type === 'multiselect' && (
            <MultiSelect
              id={`filter-${filter.id}`}
              key={filter.id}
              onChange={(value) => {
                setFilter(filter.id, value)
              }}
              options={filter.options}
              value={localValues[filter.id]}
              className="w-full md:w-56"
            />
          )}
          {filter.type === 'input' && (
            <Input
              id={`filter-${filter.id}`}
              key={filter.id}
              value={localValues[filter.id] || ''}
              onChange={(e) => {
                setFilter(filter.id, e.target.value, true)
              }}
              className="w-full md:w-64"
            />
          )}
        </div>
      ))}
      {hasAnyValues(filterValues) && (
        <Button
          className="hidden self-end md:block"
          variant="outline"
          onClick={() => resetFilters()}
        >
          Clear Filters
        </Button>
      )}
    </div>
  )
}

DataTableFilter.propTypes = {
  filters: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
  filterValues: PropTypes.object,
}
